import { t } from '@lingui/core/macro';
import ButtonIcon from '../ui/ButtonIcon';
import { useMobileNavSidebar } from '../../hooks/useUserPreferences';

/**
 * In-drawer close control for SidebarNavShell scrollerHeader.
 */
function MobileSidebarCloseButton() {
  const { closeMobileNavSidebar } = useMobileNavSidebar();

  return (
    <div className="side-nav-mobile-close">
      <ButtonIcon
        icon="close"
        onClick={closeMobileNavSidebar}
        title={t`Close`}
        className="mt-2 p-1"
      />
    </div>
  );
}

export default MobileSidebarCloseButton;
